import { Button } from '../components/Button.jsx';
import { Card } from '../components/Card.jsx';
import { RulesPanel } from '../components/RulesPanel.jsx';
import { useFocusOnMount } from '../components/useFocusOnMount.js';

export function RulesScreen({ onClose, advanced = false }) {
  const mainRef = useFocusOnMount();
  return (
    <main ref={mainRef} id="main" tabIndex={-1} className="screen screen-rules">
      <Card titleId="rules-heading">
        <div className="rules-card-header">
          <h2 id="rules-heading" className="card-title">
            How to play{advanced ? ': Advanced Mode' : ''}
          </h2>
          <Button
            onClick={onClose}
            variant="ghost"
            changesScreen
            testId="rules-close-top"
            audioCue="buttonSecondary"
          >
            Close
          </Button>
        </div>
        <RulesPanel advanced={advanced} />
        <div className="screen-actions">
          <Button
            onClick={onClose}
            variant="ghost"
            changesScreen
            testId="rules-close"
            audioCue="buttonSecondary"
          >
            Close
          </Button>
        </div>
      </Card>
    </main>
  );
}
